module.exports = __webpack_public_path__ + "static/media/sealevel.f52a757d.jpg";